// extracted by mini-css-extract-plugin
module.exports = {"partner":"Fzj2H","name":"Y5pej","description":"_84rjz","maskWrapper":"_4BgO7","threeDotsButton":"MpR0j","employeesTable":"_1hIuT"};